export default {
  border: {
    check: {
      width: '0.125rem',
    },
    box: {
      style: 'solid',
      width: '0.125rem',
    },
  },
  check_height: '0.625rem',
  check_width: '0.375rem',
  height: '1.625rem',
  margin_row: {
    right: '0.9375rem',
  },
  margin: {
    top: '0.625rem',
    right: '0.625rem',
    bottom: '0',
    left: '0',
  },
  offset_left: '0.375rem',
  offset_top: '0.75rem',
  transform_origin: 'left top',
  transform: 'scaleX(-1) rotate(135deg)',
  width: '1.625rem',
};
